import { Link } from '@remix-run/react';
import type { MenuItem } from 'types/capi/plp';

type Props = {
  isDropdown?: boolean;
  item: MenuItem;
  menuId: string;
  onSelect: (value: string) => void;
};

const FilterOptionsListItem = ({
  menuId,
  item,
  isDropdown,
  onSelect
}: Props) => {
  const defaultClasses = 'flex items-center gap-2';
  const dropDownClasses = 'p-4';
  const sideBarClasses = 'md:px-8 px-4 pb-4';

  return (
    <>
      <Link
        data-cy="desktop-filter-option"
        id={item.text}
        to={item.path}
        className={`${defaultClasses} ${isDropdown ? dropDownClasses : sideBarClasses}`}
        onClick={() => onSelect(item.text)}
        {...(menuId === 'PRICE_MENU' && { rel: 'nofollow' })}
      >
        <input
          readOnly
          name={menuId}
          checked={item.active}
          className="cursor-pointer accent-forest"
          type="radio"
        />
        <label id={item.text} className="cursor-pointer text-sm">
          {item.text === 'All' ? 'Discover all' : item.text}
        </label>
      </Link>
      {isDropdown && <hr className="border-gray-300" />}
    </>
  );
};

export default FilterOptionsListItem;
